this.trap_focus = function ($container, event_namespace) {
    var event_name = event_namespace ? 'focusin.' + event_namespace : 'focusin';
    var event_name_keyup = event_namespace ? 'keyup.' + event_namespace : 'keyup';

    $container.attr('tabindex', '-1').focus();

    $(document).on(event_name_keyup, function (event) {
        if (event.shiftKey) {
            //set shiftKey on container to detect when the user is going backwards
            $container.shiftKey = true;
        } else {
            // otherwise set to false this is to reset it if the user changes direction
            $container.shiftKey = false;
        }
    }).on(event_name, function (event) {
        //if the user reaches the end of the elements, reset to top container to tabbing loops
        if ($container[0] !== event.target && !$container.has(event.target).length) {
            var first = $container.find('button:visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:not([tabindex="-1"]):visible').first();
            var last = $container.find('button:visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:not([tabindex="-1"]):visible').last();

            if ($container.shiftKey === true) {
                //get all focasable children and then select the last one and focus it
                last.focus();
            } else {
                first.focus();
            }
        }
    });
};

this.remove_trap_focus = function ($container, event_namespace) {
    var event_name = event_namespace ? 'focusin.' + event_namespace : 'focusin';
    var event_name_keyup = event_namespace ? 'keyup.' + event_namespace : 'keyup';

    $container.removeAttr('tabindex');
    $(document).off(event_name).off(event_name_keyup);
};